// Bootstrap (CommonJS — avoids babel sourceType issues on this Mix setup)
require('bootstrap/js/src/carousel')
require('bootstrap/js/src/collapse')
require('bootstrap/js/src/dropdown')

require('swiper/css/bundle')

const initMobileNav = require('./components/mobile-nav')
const initServiceGrid = require('./components/service-grid')
const initLogoCarousel = require('./components/logo-carousel')
const initTestimonials = require('./components/testimonials')

document.addEventListener('DOMContentLoaded', () => {
  initMobileNav()
  initServiceGrid()
  initLogoCarousel()
  initTestimonials()
})
